import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import type { UseTimeseriesChartReturn } from '../../../participantData/hooks/useTimeseriesChart';
import { SeriesListItem } from '../SeriesListItem';
import { TimeSeriesControl } from './TimeSeriesControl';

interface Props {
  chart: UseTimeseriesChartReturn;
}

export const TimeSeriesList = (props: Props) => {
  const { chart } = props;

  return (
    <ChakraV3.Stack w='full'>
      {chart.participantBehaviours.map((behaviour) => (
        <SeriesListItem key={behaviour.id} behaviour={behaviour}>
          <TimeSeriesControl behaviour={behaviour} chart={chart} />
        </SeriesListItem>
      ))}
    </ChakraV3.Stack>
  );
};
